"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
function FeaturedArticleConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="relative w-full min-h-[600px] flex items-center justify-center bg-primary-900/10 animate-pulse">
        <div className="max-w-3xl w-full px-6 flex flex-col items-center space-y-6">
          <div className="h-8 w-24 bg-primary-900/20 rounded-lg" />
          <div className="h-16 w-full bg-primary-900/20 rounded-md" />
          <div className="h-6 w-48 bg-primary-900/20 rounded-md" />
          <div className="h-12 w-40 bg-primary-900/20 rounded-md" />
        </div>
      </div>;
  }
  if (error || !posts || posts.length === 0) {
    return null;
  }
  return <>
      {posts.slice(0, 1).map((post, i) => <div key={post.id} data-index={i} className="relative w-full min-h-[600px] flex items-center justify-center py-24 px-6 overflow-hidden">
          {}
          <div className="absolute inset-0 z-0">
            {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover" loading="lazy" /> : <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roofing_hero_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roofing_hero_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roofing_hero_bg.png-wvc-sizes" alt="Roofing background" className="w-full h-full object-cover" loading="lazy" />}
            {}
            <div className="absolute inset-0 bg-primary-900/85 mix-blend-multiply" />
            <div className="absolute inset-0 bg-primary-900/40" />
          </div>

          {}
          <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto text-white">
            <Badge className="bg-secondary text-secondary-foreground hover:bg-secondary/90 mb-8 text-sm px-4 py-1.5 rounded-sm border-none font-semibold tracking-wide uppercase shadow-md">
              Featured
            </Badge>

            <p className="text-secondary font-semibold tracking-wider uppercase mb-4">
              Expert insights to help you make smarter exterior decisions
            </p>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 leading-tight text-white drop-shadow-md">
              Roofing Tips & Expert Guides for MD Homeowners
            </h2>
            
            <p className="text-lg md:text-xl text-white/90 mb-4 font-sans font-medium drop-shadow-sm">
              {post.date ? new Date(post.date).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          }) : "Recent"} • 5 min read
            </p>

            <Link to="/ServicesPage" className="text-secondary hover:text-secondary/80 font-medium mb-10 transition-colors flex items-center gap-2">
              → View all roofing services
            </Link>
            
            <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-md text-base font-semibold px-8 h-14 shadow-lg transition-transform hover:-translate-y-0.5">
              <Link to={post.link || "#"}>Read Our Free Roofing Guides</Link>
            </Button>
          </div>
        </div>)}
    </>;
}
export default function FeaturedArticle() {
  const wp_query_params = {
    post_type: "post",
    per_page: 1,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="featured-article" className="bg-background w-full">
      <PostsProvider wp_query={{
      post_type: "post",
      per_page: 1,
      order: "desc",
      orderby: "date"
    }}>
        <FeaturedArticleConsumer />
      </PostsProvider>
    </section>;
}